function maxLengthValidator(value: string, length: number) {
  return (value ?? '').length <= length;
}

export default maxLengthValidator;
